import { IPage, ISearchPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";

//详情
export interface IMaterialDetail {
    id: string,
    shopId?: string,
    shopName?: string,
    shopCode?: string,
    code?: string,
    name?: string,
    nameEn?: string,
    replaceCode?: string,
    brandCode?: string,
    brandName?: string,
    unitCode?: string,
    unitName?: string,
    madeFrom?: string,
    typeCode?: string,
    typeName?: string,
    engineType?: string,
    note?: string,
    model?: string,
    status?: string | boolean,
    limitUpper?: string,
    limitLower?: string,
    buyingPrice?: string,
    sellingPrice?: string,
    wholesalePrice?: string,
    distributorPrice?: string,
    customsEntry?: string,
    repairPrice?: string,
    sourceApp?: string,
    branch?: string,
    shelfCode?: string,
    shelfId?: string,
    warehouseId?: string,
    warehouseCode?: string,
    warehouseName?: string,
    customsCode?: string,
    //
    num?: string | number,
    createTime?:moment.Moment | null | string;
	updateTime?:moment.Moment | null | string;
}
//新增
export interface IMaterialInsert extends IMaterialDetail {

}

//编辑
export interface IMaterialUpdate extends IMaterialInsert {
    id: string,
}

//搜索条件
export interface IMaterialSearchFields {

}

export interface IMaterialSearch
    extends IMaterialSearchFields, ISearchPage {
    [key: string]: any
}


class MaterialService {
    async page(searchVo: IMaterialSearch, config: object = {}) {
        const apiUrl = "/gtm/base/material/listPage";
        return await httpRequest.post<IPage<IMaterialDetail>>(apiUrl, searchVo, config);
    }
    async one(id: string, shopCode?: string) {
        const apiUrl = `/gtm/base/material/findById/${id}/${shopCode}`;
        return await httpRequest.get<IMaterialDetail>(apiUrl);
    }
    async insert(insertVo: IMaterialInsert) {
        const apiUrl = "/gtm/base/material/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: IMaterialUpdate) {
        const apiUrl = "/gtm/base/material/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //启用禁用
    async disable(id: string, status: number, shopCode: string) {
        const apiUrl = `/gtm/base/material/enableOrDisable/${shopCode}/${id}/${status}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //导入
    async import(file: { file: File }) {
        const appPageUrl = "/gtm/base/material/import";
        return await httpRequest.post<boolean>(appPageUrl, file);
    }
    //导出
    async export(searchVo: IMaterialSearch) {
        const appPageUrl = "/gtm/base/material/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }

    //下载模板
    async downloadTpl() {
        const appPageUrl = "/gtm/base/material/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }

}

export const materialService = new MaterialService();
